import classNames from 'classnames';
import React from 'react';

enum COLORS {
  primary = 'bg-primary-200 hover:bg-primary-300 active:bg-primary-400 text-white',
  secondary = 'bg-secondary-200 hover:bg-secondary-300 active:bg-secondary-400 text-white',
  outlinedPrimary = 'border border-primary-200 hover:bg-primary-100 active:bg-primary-200 active:text-white text-primary-200 bg-white',
}

interface ButtonProps<T extends React.ElementType> {
  as?: T;
  children?: React.ReactNode;
  color?: keyof typeof COLORS;
}

const NewButton = <T extends React.ElementType = 'button'>({
  children,
  as,
  color = 'primary',
  className,
  ...props
}: ButtonProps<T> & Omit<React.ComponentPropsWithoutRef<T>, keyof ButtonProps<T>>) => {
  const Component = as || 'button';

  const buttonClassName = classNames(
    COLORS[color],
    {
      'px-8': className ? !className.includes('px') : true,
    },
    'inline-block rounded-lg py-4 md:py-2 text-center font-bold',
    className
  );

  return (
    <Component className={buttonClassName} {...props}>
      {children}
    </Component>
  );
};

export default NewButton;
